import { render, staticRenderFns } from "./ChallengeStarsInfo.vue?vue&type=template&id=33a30f57&"
import script from "./ChallengeStarsInfo.vue?vue&type=script&lang=js&"
export * from "./ChallengeStarsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports